import { render, staticRenderFns } from "./RelatedPhoneNumbers.vue?vue&type=template&id=3ca64624"
import script from "./RelatedPhoneNumbers.vue?vue&type=script&lang=js"
export * from "./RelatedPhoneNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports